import React from 'react'

const SubHeading = ({ children }) => {
    return (
        <p className="font-light text-jbsGray max-w-[80%] mx-auto mt-4 text-[18px] sm:text-[20px] md:text-[22px] lg:text-[24px] leading-snug">
            {children}
        </p>

    )
}

export default SubHeading